import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Dialog as MuiDialog,
} from '@mui/material';
import React, { FunctionComponent } from 'react';

interface DialogProps {
  open: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  title: string;
  description: string;
  submitText?: string;
  isDestructive?: boolean;
}

export const Dialog: FunctionComponent<DialogProps> = ({
  open,
  onCancel,
  onSubmit,
  title,
  description,
  isDestructive = false,
  submitText,
}) => {
  return (
    <MuiDialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Annuler</Button>
        <Button
          onClick={onSubmit}
          autoFocus
          sx={isDestructive ? { color: 'error.main' } : undefined}
        >
          {submitText ?? 'Valider'}
        </Button>
      </DialogActions>
    </MuiDialog>
  );
};
